import { render } from "./UserReviewsModal.vue?vue&type=template&id=1f231c8e&scoped=true"
import script from "./UserReviewsModal.vue?vue&type=script&lang=js"
export * from "./UserReviewsModal.vue?vue&type=script&lang=js"

import "./UserReviewsModal.vue?vue&type=style&index=0&id=1f231c8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f231c8e"]])

export default __exports__